import { render, staticRenderFns } from "./DisplayMode.vue?vue&type=template&id=0fadd56d&"
import script from "./DisplayMode.vue?vue&type=script&lang=js&"
export * from "./DisplayMode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports